import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";

import { TAGS } from "./common/tags";
import { getProfileEndpoint } from "./endpoints/getProfile.endpoint";
import { getUserConsentsEndpoint } from "./endpoints/getUserConsents.endpoint";
import { saveAddressEndpoint } from "./endpoints/saveAddress.endpoint";
import { updateAgeVerificationEndpoint } from "./endpoints/updateAgeVerification.endpoint";
import { updateCustomAttributesEndpoint } from "./endpoints/updateCustomAttributes.endpoint";

export const profileApiSlice = createApi({
  reducerPath: "profileApi",
  baseQuery: fakeBaseQuery(),
  tagTypes: [TAGS.PROFILE],
  endpoints: (builder) => ({
    ...getProfileEndpoint(builder),
    ...getUserConsentsEndpoint(builder),
    ...saveAddressEndpoint(builder),
    ...updateAgeVerificationEndpoint(builder),
    ...updateCustomAttributesEndpoint(builder),
  }),
});
export const {
  useGetProfileQuery,
  useGetUserConsentsQuery,
  useSaveAddressMutation,
  useUpdateAgeVerificationMutation,
  useUpdateCustomAttributesMutation,
} = profileApiSlice;
